import { CourseCardsListCombinedProps } from './types';

const usePresenter = (props: CourseCardsListCombinedProps): CourseCardsListCombinedProps => {
  return props;
};

export default usePresenter;
